import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MediaLibraryLayer from "../components/MediaLibraryLayer";

const MediaLibrary = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Media Library" />
      <MediaLibraryLayer />
    </MasterLayout>
  );
};

export default MediaLibrary;
